<script>
  import AppFooter from './Footer.vue';
  import VoltarAoTopo from './VoltarAoTopo.vue';
  import PageHeader from './PageHeaderPaginaAcessos.vue';
  import "../js/inspinia";

  export default {
    name: 'layout',
    components: { PageHeader, AppFooter, VoltarAoTopo }
  }
</script>

<template>
  <div id="wrapper">
    <div id="page-wrapper" class="gray-bg" style="margin: 0 0 0 0;">
      <page-header></page-header>

      <router-view></router-view>
      
      <div class="padding-20"></div>
      
      <app-footer></app-footer>
      
      <voltar-ao-topo></voltar-ao-topo>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/componentes/LayoutPaginaAcessos.vue